import React from 'react';
import BaseModel from '../../BaseModal'
import { LineView } from '../../styles/WrapperStyles';
import styled from 'styled-components';

const ParentDiv = styled.div`
  width: 445px;
  height: 239px;
  border-radius: 20px;
`;

const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
  cursor: pointer;
`;

const BannedOptionsModal = (props) => {

    return (
        <BaseModel closeModal={() => props.closeModal()}>
            <ParentDiv>
                {props.reportOptions.map((option, pos) => (
                    <div key={pos}>
                        <TextView onClick={() => props.getBanOption(option)}>{option}</TextView>
                        <LineView />
                    </div>
                ))}
            </ParentDiv>
        </BaseModel>
    );
};

export default BannedOptionsModal;
